module.exports = __webpack_public_path__ + "td/img/mi-no-img.21a8c237.png";